import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { BrowserRouter } from 'react-router';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { SocialAuthProvider } from './context/SocialAuthContext';
import { LogistrationHeader } from './components/LogistrationHeader/LogistrationHeader';
import { AppRouter } from './router';
import { appContext } from './services/appContext';
export function App() {
    return (_jsx(BrowserRouter, { children: _jsx(GoogleOAuthProvider, { clientId: appContext.googleAppID, children: _jsx(SocialAuthProvider, { children: _jsxs("div", { className: "flex min-h-screen flex-col", children: [_jsx(LogistrationHeader, {}), _jsx("div", { className: "flex flex-1 flex-col", children: _jsx(AppRouter, {}) })] }) }) }) }));
}
